import React, { useState } from 'react';
import apiService, { errorHelpers, formatHelpers, authHelpers } from '../../../utils/apiService';

const CertificateUpload = () => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [report, setReport] = useState(null);

    const onFileChange = e => {
        const selectedFile = e.target.files[0];
        console.log('Selected file:', selectedFile); // Debug log
        setFile(selectedFile);
        setReport(null);
    };

    const downloadTemplate = async () => {
        try {
            const res = await apiService.admin.downloadCertificateTemplate();
            const url = URL.createObjectURL(res.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'certificate_upload_template.csv';
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (err) {
            alert(errorHelpers.getErrorMessage(err));
        }
    };

    const handleUpload = async () => {
        if (!file) {
            alert('Please select a file first');
            return;
        }

        // Validate file type
        if (!file.name.toLowerCase().endsWith('.csv')) {
            alert('Please select a CSV file');
            return;
        }

        console.log('Uploading file:', file.name, 'Size:', file.size); // Debug log

        setUploading(true);
        try {
            // Call the API service method directly with the file
            const { data } = await apiService.admin.uploadCertificates(file);
            setReport(data.report);
            console.log('Upload successful, report:', data.report); // Debug log
        } catch (err) {
            console.error('Upload error:', err); // Debug log
            alert(errorHelpers.getErrorMessage(err));
        } finally {
            setUploading(false);
        }
    };

    const downloadReport = () => {
        if (!report?.length) return;
        const headers = Object.keys(report[0]);
        const csvRows = [
            headers.join(','),
            ...report.map(row =>
                headers.map(h => {
                    // Convert value to string and handle null/undefined
                    const value = row[h] == null ? '' : String(row[h]);
                    // Escape quotes by doubling them and wrap in quotes
                    return `"${value.replace(/"/g, '""')}"`;
                }).join(',')
            )
        ];
        const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'certificate_upload_report.csv';
        document.body.appendChild(a);
        a.click();
        a.remove();
    };

    return (
        <div className="certificate-upload">
            <h2>📤 Certificate Upload</h2>

            <button className="btn btn-secondary" onClick={downloadTemplate}>
                Download CSV Template
            </button>

            <div className="upload-section">
                <input
                    type="file"
                    accept=".csv"
                    onChange={onFileChange}
                />
                {file && (
                    <div className="file-info">
                        Selected: {file.name} ({(file.size / 1024).toFixed(2)} KB)
                    </div>
                )}
                <button
                    className="btn btn-primary"
                    onClick={handleUpload}
                    disabled={!file || uploading}
                >
                    {uploading ? 'Uploading…' : 'Upload CSV'}
                </button>
            </div>

            {report && (
                <div className="upload-report">
                    <h3>Upload Report</h3>
                    <div className="report-summary">
                        Total: {report.length} |
                        Success: {report.filter(r => r.status === 'success').length} |
                        Failed: {report.filter(r => r.status === 'failed').length}
                    </div>
                    <table className="table">
                        <thead>
                            <tr>
                                {Object.keys(report[0]).map(col => (
                                    <th key={col}>{col}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {report.map((row, idx) => (
                                <tr key={idx} className={row.status === 'failed' ? 'table-danger' : 'table-success'}>
                                    {Object.keys(row).map(col => (
                                        <td key={col}>{row[col]}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <button className="btn btn-secondary" onClick={downloadReport}>
                        Download Report CSV
                    </button>
                </div>
            )}
        </div>
    );
};

export default CertificateUpload;